import { media } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const TextFieldContainer = styled('div')`
  input {
    color: ${({ theme }) => theme.color.white};
    ${({ theme }) => theme.typography.megaStrong}
    ${media.xsDown`
      ${({ theme }) => theme.typography.largeStrong}
    `}
  }
`;
